import { Spinner, Tick, Warning2 } from '@/components/icons';
import { Button } from '@/components/ui/button';

export type SaveStatus = 'saved' | 'unsaved' | 'saving' | 'error';

export function SaveIndicator({ status, onRetry }: { status: SaveStatus; onRetry: () => void }) {
    if (status === 'saving') {
        return (
            <span className="inline-flex items-center gap-1.5 text-sm text-muted-foreground">
                <Spinner className="size-4 animate-spin" />
                Salvando…
            </span>
        );
    }

    if (status === 'error') {
        return (
            <span className="inline-flex items-center gap-2 text-sm text-destructive">
                <Warning2 className="size-4" />
                Erro ao salvar
                <Button variant="link" size="sm" className="h-auto p-0" onClick={onRetry}>
                    Tentar novamente
                </Button>
            </span>
        );
    }

    if (status === 'unsaved') {
        return <span className="text-sm text-muted-foreground">Alterações não salvas</span>;
    }

    return (
        <span className="inline-flex items-center gap-1.5 text-sm text-emerald-600">
            <Tick className="size-4" />
            Salvo
        </span>
    );
}
